import Gif from './screens/Gif';

function App() {
  return (
    <Gif />
  );
}

export default App;
